export default class RemoteSiteLauncher {
    URL: string = '';
    navigationKey: string = '';
    metaData?: boolean;

    constructor(enable?: boolean) {
        this.metaData = enable;
    }
}
